import { createSlice } from "@reduxjs/toolkit";
import {
  discussionBoardInitialStatus,
  GetDiscussionBoardData,
  GetSingleDiscussionBoardData,
} from "../../../types/discussionBoard/discussionBoard";
import {
  createDiscussionBoardAsync,
  getAllDiscussionBoardAsync,
  singDiscussionBoardAsync,
  updateDiscussionBoardAsync,
} from "./discussionBoardApi";

const initialState: discussionBoardInitialStatus<
  GetDiscussionBoardData,
  GetSingleDiscussionBoardData
> = {
  loading: false,
  manageLoading: false,
  discussionBoardList: [],
  singleDiscussionBoardData: null,
  countDiscussionBoard: 0,
};

const discussionBoardSlice = createSlice({
  name: "admin-discussion-Board",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // create
    builder
      .addCase(createDiscussionBoardAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(createDiscussionBoardAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(createDiscussionBoardAsync.rejected, (state) => {
        state.manageLoading = false;
      });

    // get all
    builder
      .addCase(getAllDiscussionBoardAsync.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllDiscussionBoardAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.discussionBoardList = action.payload.data;
        state.countDiscussionBoard = action.payload.length;
      })
      .addCase(getAllDiscussionBoardAsync.rejected, (state) => {
        state.loading = false;
        state.discussionBoardList = [];
        state.countDiscussionBoard = 0;
      });

    // update
    builder
      .addCase(updateDiscussionBoardAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(updateDiscussionBoardAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(updateDiscussionBoardAsync.rejected, (state) => {
        state.manageLoading = false;
      });

    // single
    builder
      .addCase(singDiscussionBoardAsync.pending, (state) => {
        state.manageLoading = true;
        state.singleDiscussionBoardData = null;
      })
      .addCase(singDiscussionBoardAsync.fulfilled, (state, action) => {
        state.manageLoading = false;
        state.singleDiscussionBoardData = action.payload;
      })
      .addCase(singDiscussionBoardAsync.rejected, (state) => {
        state.manageLoading = false;
        state.singleDiscussionBoardData = null;
      });
  },
});

export default discussionBoardSlice;
